import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "star-rating" }
const _hoisted_2 = ["src", "onClick"]

import backend from "apps/shared/backend";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'star-rating',
  props: {
    filledStarPath: {},
    emptyStarPath: {},
    rateEpisodePath: {},
    rating: {},
    maxRating: {}
  },
  setup(__props: any) {

const props = __props;



const starCount = Number(props.maxRating);
const currentRating = ref<number>(Number(props.rating));
const submittingRating = ref(false);

const setRating = async (rating: number) => {
  if (rating != currentRating.value) {
    const result = await backend(
      props.rateEpisodePath,
      "POST",
      {
        rating: rating,
      }
    );

    if (result.data.success) {
      currentRating.value = rating;
    }
  }
}

const imagePath = (indx: number) => {
  return indx <= currentRating.value
    ? props.filledStarPath
    : props.emptyStarPath
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(starCount), (indx) => {
      return (_openBlock(), _createElementBlock("img", {
        key: indx,
        src: imagePath(indx),
        onClick: ($event: any) => (setRating(indx))
      }, null, 8, _hoisted_2))
    }), 128))
  ]))
}
}

})